import { BrowserModule } from '@angular/platform-browser';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {SectionComponent} from './sections/section.component';

import {SearchPanelComponent} from './panel/searchPanel.component';

import {BoxComponent} from '../app/boxes/boxes.component';

import { ToastrModule } from 'ngx-toastr';

import { FormsModule ,ReactiveFormsModule} from '@angular/forms';

import {SearchPipe} from './pipes/search';

import {ListItemComponent} from './list_item/list_item.component';

import { APP_ROUTES } from './app.routes';

import { RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';

import {DashboardModule} from './dashboard/dashboard.module';

import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';

import { HttpClientModule } from '@angular/common/http';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { Layout1Component } from './layout/open_layout.component';

import {NewsletterViewComponent} from './newsletter_view/newsletterview.component';

import {SharedModule} from './shared/shared.module';

import { AutoLoginComponent } from './autologin/autologin.component';

import {AppSettings} from './settings';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SignupComponent } from './signup/signup.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule, GoogleAnalyticsService } from 'ngx-google-analytics';



@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    Layout1Component,
    NewsletterViewComponent,
    AutoLoginComponent,
    ForgotPasswordComponent,
    SignupComponent,
    ResetPasswordComponent
  ],
  imports: [
    BrowserModule,
    NgbModule,
    DashboardModule,
    SharedModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot() ,
    RouterModule.forRoot(APP_ROUTES),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxGoogleAnalyticsModule.forRoot(AppSettings.GA_ID),
    NgxGoogleAnalyticsRouterModule,

  ],
  exports:[ ],

  providers: [
     {provide:'googleTagManagerId',useValue:AppSettings.GTM_ID},
     GoogleAnalyticsService
    // {provide: 'googleTagManagerId', useValue: 'GTM-N6Z9VQM'}
  ],
  bootstrap: [AppComponent],

})
export class AppModule { }
